import { colours } from 'bz-core-controls/styles/colours';

const styles = {
  button: {
    backgroundColor: colours.green800,
    color: colours.white,
    '&:hover': {
      backgroundColor: colours.green900
    }
  },
  buttonPanel: { textAlign: 'center' },
  localPreview: {
    display: 'flex',
    width: '240px',
    height: '180px',
    overflow: 'hidden',
    background: colours.black,
    '& video': {
      maxHeight: '100%',
      width: '100%'
    },
    '@media (min-width: 400px)': {
      height: 300,
      width: 400
    }
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridAlignContent: 'center',
    gridColumnGap: '20px',
    '@media (max-width: 820px)': {
      gridTemplateColumns: '1fr'
    }
  },
  message: { color: colours.white, fontSize: 16, textAlign: 'center' },
  flipContent: {
    transform: 'rotateY(180deg)',
    zIndex: 200,
    margin: 'auto'
  },
  cameraWrapper: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  containerCentre: {
    maxWidth: 900,
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: 10
  },
  videoElements: {
    position: 'relative',
    width: '100%',
    height: '100%',
    minHeight: 600,
    background: 'black',
    display: 'grid',
    gridTemplateColumns: '1fr 5fr',
    textAlign: 'center',
    '& video': {
      maxHeight: '80vh',
      width: '100%'
    }
  },
  fullScreen: {
    '& video': {
      maxHeight: '100vh'
    }
  },
  inputWrapper: {
    '& input': {
      fontWeight: '400',
      fontFamily: 'Nunito Sans, Roboto, Sanss',
      margin: 3,
      MozAppearance: 'textfield',
      width: 28,
      padding: 2,
      borderRadius: '3px',
      fontSize: '2.8rem',
      height: '40px',
      textAlign: 'center',
      textTransform: 'uppercase'
    },
    '@media (max-width: 480px)': {
      ' & input': {
        fontSize: '2rem',
        width: 24,
        margin: '0.4rem'
      }
    },
    '@media (max-width: 380px)': {
      ' & input': {
        fontSize: '2rem',
        width: 22,
        margin: '0.4rem'
      }
    }
  },

  inputStyleInvalid: {
    border: '2px solid green'
  },
  alert: {
    padding: 8,
    backgroundColor: colours.red100,
    border: `1px solid ${colours.red300}`,
    color: colours.red,
    borderRadius: 4,
    margin: 10
  }
};
export default styles;
